import React from 'react';
import useIsomorphicLayoutEffect from '../use-isomorphic-layout-effect';

export const useLockedBody = (initialLocked = false): [boolean, (locked: boolean) => void] => {
  const [locked, setLocked] = React.useState(initialLocked);

  useIsomorphicLayoutEffect(() => {
    if (!locked) return;

    const originalOverflow = document.body.style.overflow;

    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [locked]);

  React.useEffect(() => {
    if (locked !== initialLocked) {
      setLocked(initialLocked);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialLocked]);

  return [locked, setLocked];
};

export default useLockedBody;
